export default __webpack_public_path__ + "static/media/mlogo.b503da52.png";